// Groups a flat skills list into ordered skill-group buckets.
// Each skill is expected to carry skill_group_id + skill_group_name.
export function groupSkills(skills) {
  const map = new Map();
  for (const s of skills || []) {
    const gid = s.skill_group_id || '__ungrouped__';
    const gname = s.skill_group_name || 'Ungrouped';
    if (!map.has(gid)) map.set(gid, { group_id: gid, group_name: gname, skills: [] });
    map.get(gid).skills.push(s);
  }
  const arr = [...map.values()].sort((a, b) => a.group_name.localeCompare(b.group_name));
  arr.forEach(g => g.skills.sort((a, b) => (a.name || '').localeCompare(b.name || '')));
  return arr;
}
